import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../../services/api';
import logo from '../../../images/logoaccess.png';
import '../../../css/financeiro-parcela-pagar.css';
import { toast } from 'react-toastify';
import { getText } from '../../../util/translations';
import Processando from '../../../components/Processando';

const logoStyle = {
  maxWidth: '100%',
  maxHeight: '48px',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
};

export default function CadastroEventoParticipanteConviteRecusado({ match }) {
  const id = match.params.id;
  const [evento, setEvento] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const { state } = useLocation();
  const idioma = state?.idioma ?? 'both';

  const buscar = () => {
    setIsLoading(true);
    setIsError(false);
    api({
      method: "get",
      action: '/eventoSemLogin/' + id,
    }).then(response => {
      var dadosEvento = response.data.data;
      setEvento(dadosEvento);
      setIsLoading(false);
    }).catch(err => {
      setIsLoading(false);
      setIsError(true);
      toast.error(getText('error') + getText('errorRefreshPage'));
    });
  };//buscar

  useEffect(() => { //onload
    buscar();
  },
    // eslint-disable-next-line
    []);

  return (
    <div
      className="fin-pp"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'none',
        backgroundColor: (evento.cor !== undefined) ? evento.cor : '#AAAAAA',
      }}
    >
      {isLoading && <Processando idioma={idioma} />}
      <div style={{ width: '100%', maxWidth: 480, padding: '0 16px' }}>
        <div className="fin-pp__card" style={{ padding: 32 }}>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            {localStorage.getItem('logomarcaEvento') ?
              <img alt="" src={localStorage.getItem('logomarcaEvento')} style={logoStyle} className='mb-4' /> :
              <img alt="" src={logo} style={logoStyle} className='mb-4' />
            }
          </div>
          { }
          <p style={{ textAlign: 'center', color: 'var(--fin-tx)' }}>
            {getText('refusalRegistered')} <strong>{evento.nome}</strong> {getText('wasRegistered')}
          </p>
          <p style={{ textAlign: 'center', color: 'var(--fin-mt)' }}>{getText('thankYou')}</p>
        </div>
      </div>
    </div>
  );
}
